import { createTheme } from '@mui/material/styles';
import type { ThemeOptions } from '@mui/material/styles';
import { lightPalette, darkPalette } from './palette';

// Common theme options
const getBaseTheme = (): ThemeOptions => ({
  typography: {
    fontFamily: '"Roboto", sans-serif',
    h1: {
      fontFamily: '"Montserrat", sans-serif',
      fontWeight: 900,
      textTransform: 'uppercase',
    },
    h2: {
      fontFamily: '"Montserrat", sans-serif',
      fontWeight: 900,
      textTransform: 'uppercase',
    },
    h3: {
      fontFamily: '"Montserrat", sans-serif',
      fontWeight: 900,
      textTransform: 'uppercase',
    },
    h4: {
      fontFamily: '"Montserrat", sans-serif',
      fontWeight: 900,
      textTransform: 'uppercase',
    },
    h5: {
      fontFamily: '"Montserrat", sans-serif',
      fontWeight: 900,
      textTransform: 'uppercase',
    },
    h6: {
      fontFamily: '"Montserrat", sans-serif',
      fontWeight: 900,
      textTransform: 'uppercase',
    },
    button: {
      fontWeight: 500,
    },
  },
  shape: {
    borderRadius: 8,
  },
  spacing: 8,
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          padding: '8px 16px',
        },
        contained: {
          boxShadow: 'none',
          '&:hover': {
            boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.2)',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.08)',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
        },
        elevation1: {
          boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.08)',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundImage: 'none',
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        variant: 'outlined',
        size: 'small',
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
      },
    },
  },
});

// Create light theme
export const lightTheme = createTheme({
  ...getBaseTheme(),
  palette: lightPalette,
});

// Create dark theme
export const darkTheme = createTheme({
  ...getBaseTheme(),
  palette: darkPalette,
});

// Module-specific theme creator
export const createModuleTheme = (module: string, isDark: boolean = false) => {
  const baseTheme = isDark ? darkTheme : lightTheme;
  const moduleColorMap: Record<string, string> = {
    fulfill: '#ba3636',
    material: '#990000',
    availability: '#1A93AE',
    engage: '#7A936A',
    count: '#D8AD37',
    verify: '#684551',
    events: '#2B4570',
  };

  const moduleColor = moduleColorMap[module.toLowerCase()];
  
  if (!moduleColor) {
    return baseTheme;
  }

  return createTheme({
    ...baseTheme,
    palette: {
      ...baseTheme.palette,
      primary: {
        ...baseTheme.palette.primary,
        main: moduleColor,
      },
    },
  });
};